import React, { Component } from 'react'
import { AppContext } from '@lightspeed-invoicing/core-client/frontend'

class Image extends Component {

    constructor(props, context) {
        super(props, context);
        this.state = {
            src: '',
            alt: '',
            className: this.props.className || '',
            imageClassName: this.props.imageClassName || '',
            image: this.props.image || null,
            imageId: this.props.imageId || '',
            linkUrl: this.props.linkUrl || '',
            rounded: this.props.rounded !== false,
            style: this.props.style || {},
            isPdf: this.props.isPdf || false,
        }
        this.loadImage = this.loadImage.bind(this)
        this.setSize(this.props.size)
    }



    componentWillReceiveProps(nextProps) {
        const currentImageId = this.state.imageId
        this.setState({
            imageClassName: nextProps.imageClassName,
            className: nextProps.className,
            image: nextProps.image || null,
            imageId: nextProps.imageId || '',
            linkUrl: nextProps.linkUrl || '',
            rounded: nextProps.rounded !== false,
            style: nextProps.style || {},
        }, () => {
            this.setSize(nextProps.size)
            if (nextProps.imageId !== currentImageId || nextProps.image) {
                this.loadImage()
            }
        })


    }

    setSize(size) {
        switch (size) {
            case 'very-small':
                this.size = '50x50'
                this.maxWidth = '50px'
                this.maxHeight = '50px'
                break
            case 'small':
                this.size = '150x150'
                this.maxWidth = '150px'
                this.maxHeight = '150px'
                break
            case 'medium':
                this.size = '640x480'
                this.maxWidth = '640px'
                this.maxHeight = '480px'
                if (this.state.isPdf) {
                    this.maxWidth = '1280px'
                    this.maxHeight = '800px'
                }
                break
            case 'large':
            default:
                this.size = '1280x800'
                this.maxWidth = '1280px'
                this.maxHeight = '800px'
                break
        }
    }

    loadImage() {
        if (this.state.image) {
            const src = this.state.image.attributes.publicUrlBySize[this.size] ? this.state.image.attributes.publicUrlBySize[this.size] : this.state.image.attributes.publicUrl
            this.setState({
                src: src,
                alt: this.state.image.attributes.originalFileName,
            })
        } else if (this.state.imageId) {
            AppContext.getApiClient().get('/images/' + this.state.imageId + '?size=' + this.size).then(res => {
                const src = res.attributes.publicUrlBySize[this.size] ? res.attributes.publicUrlBySize[this.size] : res.attributes.publicUrl
                this.setState({
                    src: src,
                    alt: res.attributes.originalFileName
                })
            })
        }

    }

    UNSAFE_componentWillMount() {
        this.loadImage()
    }

    renderImage(linkUrl, alt) {
        const style = { maxHeight: this.maxHeight, maxWidth: this.maxWidth }
        Object.assign(style, this.state.style)
        let img = <img style={style}
            src={this.state.src} alt={alt[alt.length - 1]}
            className={"box-shadow " + this.state.imageClassName + (this.state.rounded ? " rounded" : "")}
        />

        if (linkUrl && !linkUrl.includes('//')) {
            linkUrl = '//' + linkUrl
        }
        if (linkUrl) {
            return (
                <a target="_blank" href={linkUrl}>{img}</a>
            )
        } else {
            return img
        }
    }

    render() {
        const alt = this.state.alt.split('/')
        return (
            <picture className={this.state.className} >
                {this.renderImage(this.state.linkUrl, alt)}
            </picture>
        )
    }
}

export default Image





// WEBPACK FOOTER //
// ./src/common/image/image.component.jsx